import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const SuperAdminLogin = () => {
    // Hooks
    const navigate = useNavigate();

    // State
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // تابع ورود سوپر ادمین
    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const apiUrl = 'https://sseo.afaq.lc/seo_architect_api/superadmin_login.php';
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await response.json();

            if (data.success) {
                localStorage.setItem('superAdminAuthToken', data.token);
                // هدایت کاربر به پنل ادمین پس از ورود موفق
                navigate('/admin');
            } else {
                setError(data.message || 'خطا در ورود.');
            }
        } catch (err) {
            setError('خطای شبکه.');
        } finally {
            setLoading(false);
        }
    };

    // View اصلی
    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleLogin}>
                <h2>ورود سوپر ادمین</h2>
                <p>برای دسترسی به پنل مدیریت وارد شوید</p>
                <div className="input-group">
                    <label htmlFor="username-admin">نام کاربری</label>
                    <input id="username-admin" type="text" value={username} onChange={e => setUsername(e.target.value)} required />
                </div>
                <div className="input-group">
                    <label htmlFor="password-admin">رمز عبور</label>
                    <input id="password-admin" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" disabled={loading}>
                    {loading ? 'در حال بررسی...' : 'ورود به پنل مدیریت'}
                </button>
            </form>
        </div>
    );
};

export default SuperAdminLogin;